import {debugPayments} from '../debug/debugPay';
import {
  checkInitializationCloudPayments,
  getPublicId,
} from "@/helpers/pay/helpers";
import { setYandexMetric } from "@/helpers/pay/metric/yandexMetric";
import {send} from "@/components/fetchData";
import {store} from "@/store/store.js";

/** Метод, создающий оплату в cloud payments
 * @param {String} description - описание покупки
 * @param {Array} listCourses - массив курсов за которых происходит оплата
 * @param {String} typeCourses - тип курса (например: gk, pgk)
 * @param {Number} orderId - id заказа
 * @param {Number} userId - id пользователя
 * @param {String} userEmail - email пользователя
 * @param {String} userName - имя пользователя
 * @param {Number} userVkId - id vk пользователя
 * @param {Function} successPay - функция, которая вызывается при успешной оплате (коллбэк успеха)
 * @param {Function} errorPay - функция, которая вызывается при не успешной оплате (коллбэк неудачи)
 * @param {(String|Number)} telephone - телефон пользователя
 * */
export const pay = function (description = null,
                             listCourses,
                             typeCourses,
                             orderId,
                             userId,
                             userEmail,
                             userName,
                             userVkId,
                             telephone,
                             successPay = null,
                             errorPay = null,
) {
  // eslint-disable-next-line no-undef

  let resultAmount = null;
  let payOptions;

  // функция, вызываемая при успешной оплате
  let successFunc = (options) => {
    setYandexMetric(listCourses, resultAmount, 'cloud payments');
    typeof successPay === 'function' && successPay(listCourses, options);
  }

  // функция, вызываемая, если при оплате произошла ошибка
  let errorFunc = (reason, options) => {
    if (typeof errorPay === 'function') {
      errorPay(reason, options);

      debugPayments({
        type: 2, // тип дебага / 1 - выполняется до платежной функции / 2 - выполняется при ошибке
        fileName: 'payOrder.js',
        functionName: 'pay',
        data: payOptions,
        url: JSON.stringify(window.location),
        userAgent: navigator.userAgent,
        reason: reason,
        options: options,
      });
    }
  };

  // Получить сумму заказа перед оплатой
  let getAmountOrder = () => {
    return new Promise((resolve, reject) => {
      send
        .post("unregistered.php", {
          module: "get_payment_cloud_pay",
          order_id: orderId,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
    })
  };

  // Создает оплату в Cloud Payments
  let createPay = (amount) => {
    checkInitializationCloudPayments(errorPay);
    const publicId = getPublicId(); // ключи для оплат

    resultAmount = amount;

    payOptions = {
      publicId: publicId,
      description: description, // Описание платежа
      amount: resultAmount, // Сумма
      currency: 'RUB', // Валюта
      accountId: userId, // Идентификатор плательщика (необязательно)
      userEmail: userEmail,  // Email пользователя
      requireuserEmail: true,
      skin: "classic", // Дизайн виджета
      data: {
        name: userName, // Имя пользователя
        nick: `https://vk.com/id${userVkId}`, // Ссылка на страницу в вк
        comment: description, // Описание покупки
        payload: { // Набор параметров передающийся в api
          order_id: orderId,
        }
      },
      payer: {
        phone: telephone,
      },
    };

    new cp.CloudPayments().charge(
      payOptions,
      successFunc,
      errorFunc,
    );
  };

  getAmountOrder().then(
    response => createPay(response.amount),
    error => errorFunc(error),
  )
}